// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0px;
  margin: 0px;
}

.toolbar-nav-container, .allcontact-nav, .contact-nav {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  white-space: nowrap;
  background: var(--surface-primary);
}
.toolbar-nav-container li, .allcontact-nav li, .contact-nav li {
  list-style: none;
  padding: 1.688rem 0.938rem;
  font-weight: 600;
  cursor: pointer;
  color: var(--text-primary);
  font-size: 0.875rem;
  letter-spacing: 0.84px;
  border-bottom: 2px solid transparent;
  min-width: 5.625rem;
  text-align: center;
}
@media (max-width: 755px) {
  .toolbar-nav-container li, .allcontact-nav li, .contact-nav li {
    padding: 1.688rem 0.238rem;
    min-width: unset;
  }
}
@media (max-width: 724px) {
  .toolbar-nav-container li, .allcontact-nav li, .contact-nav li {
    padding: 1.688rem 0.238rem;
    min-width: unset;
  }
}
@media (max-width: 576px) {
  .toolbar-nav-container, .allcontact-nav, .contact-nav {
    justify-content: space-evenly;
  }
  .toolbar-nav-container li, .allcontact-nav li, .contact-nav li {
    padding: 0.781rem 0.938rem;
  }
}

.recording-icon {
  position: absolute;
  color: var(--color-danger);
  right: 1.25rem;
  top: 1.125rem;
  font-size: 0.75rem;
}

.contact-nav {
  justify-content: space-around !important;
  margin: 0.5rem 0rem 1rem;
}

.allcontact-nav {
  justify-content: flex-start !important;
  margin: 0.5rem 2rem 1rem;
}

.toolbar-nav-active {
  color: var(--color-accent) !important;
  border-bottom: 2px solid var(--color-accent) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/nav/nav.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCAAA;AACJ;AAEI;EACI,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AAEQ;EAZJ;IAaQ,0BAAA;IACA,gBAAA;EACV;AACF;AACQ;EAjBJ;IAkBQ,0BAAA;IACA,gBAAA;EAEV;AACF;AAEI;EAjCJ;IAkCQ,6BAAA;EACN;EACM;IACI,0BAAA;EACV;AACF;;AAKA;EACI,kBAAA;EACA,0BAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AAFJ;;AAKA;EAEI,wCAAA;EACA,wBAAA;AAHJ;;AAMA;EAEI,sCAAA;EACA,wBAAA;AAJJ;;AAOA;EACI,qCAAA;EACA,uDAAA;AAJJ","sourcesContent":["* {\n    padding: 0px;\n    margin: 0px;\n}\n\n.toolbar-nav-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    position: relative;\n    white-space: nowrap;\n    background: var(--surface-primary);\n\n\n    li {\n        list-style: none;\n        padding: 1.688rem 0.938rem;\n        font-weight: 600;\n        cursor: pointer;\n        color: var(--text-primary);\n        font-size: 0.875rem;\n        letter-spacing: 0.84px;\n        border-bottom: 2px solid transparent;\n        min-width: 5.625rem;\n        text-align: center;\n\n        @media(max-width: 755px) {\n            padding: 1.688rem 0.238rem;\n            min-width: unset;\n        }\n\n        @media(max-width: 724px) {\n            padding: 1.688rem 0.238rem;\n            min-width: unset;\n        }\n\n    }\n\n    @media(max-width: 576px) {\n        justify-content: space-evenly;\n\n        li {\n            padding: 0.781rem 0.938rem;\n        }\n\n    }\n\n}\n\n.recording-icon {\n    position: absolute;\n    color: var(--color-danger);\n    right: 1.25rem;\n    top: 1.125rem;\n    font-size: 0.75rem;\n}\n\n.contact-nav {\n    @extend .toolbar-nav-container;\n    justify-content: space-around !important;\n    margin: 0.5rem 0rem 1rem;\n}\n\n.allcontact-nav {\n    @extend .toolbar-nav-container;\n    justify-content: flex-start !important;\n    margin: 0.5rem 2rem 1rem;\n}\n\n.toolbar-nav-active {\n    color: var(--color-accent) !important;\n    border-bottom: 2px solid var(--color-accent) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
